/**
 * @return {string}
 */
module.exports = function getWhitepaper2024EmailFormName() {
    return "Whitepaper 2024";
}
